const OG_IMAGE = "https://rizkyilhampra.dev/social-preview.svg";

export const SITE = {
  url: "https://rizkyilhampra.dev",
  name: "Rizky Ilham Pratama",
  author: "Rizky Ilham Pratama",
  jobTitle: "Software Engineer",
  locale: "en_US",
  ogImage: OG_IMAGE,
  ogImageAlt: "Rizky Ilham Pratama",
  twitterCard: "summary_large_image",
  twitterSite: "@rizkyilhampra",
  twitterCreator: "@rizkyilhampra",

  typewriterTexts: [
    "Software Engineer in support and infrastructure",
    "Exploring technology and keeping things over-engineered",
    "Using Vim and Arch Linux BTW",
    "Sharing open-source projects and TIL notes",
  ],

  routes: {
    home: {
      title: "",
      description:
        "Rizky Ilham Pratama — Software Engineer working in support and infrastructure. Passionate about Arch Linux, Vim, open-source development, and sharing TIL notes.",
    },
    tilIndex: {
      title: "Today I Learned",
      description:
        "Short, interconnected notes by Rizky Ilham Pratama on Linux, self-hosting, developer tooling, and things learned along the way.",
    },
    tagsIndex: {
      title: "Browse TIL notes by tag",
      description:
        "Explore Rizky Ilham Pratama's Today I Learned digital garden by topic and tag.",
    },
    notFound: {
      title: "Page not found",
      description: "This page does not exist on rizkyilhampra.dev.",
    },
  },
};
